// extracted by mini-css-extract-plugin
export default {"detailContent":"CommerceNoticeDetail_detailContent__-v7ZD"};